import React, { Component } from 'react';
import { connect } from 'react-redux';

import { canByLicensing } from 'utils/licensing/licensingChecker';
import { getAppointmentsByPortalUser } from 'services/appointment.service';
import Calendar from './Calendar';

const UPDATE_INTERVAL_IN_SECONDS = 30;

let timerId;

class CalendarView extends Component {
	state = {
		appointments: [],
	};

	componentWillUnmount() {
		clearTimeout(timerId);
	}

	getAppointments = async ({ from, to }) => {
		if (!canByLicensing('scheduler.scheduleCall')) return;
		this.props.setLoading(true);
		try {
			const { userId, selectedCustomerRepresentative } = this.props;

			const appointments = await getAppointmentsByPortalUser({
				from,
				to,
				userId: selectedCustomerRepresentative?._id || userId,
			});
			this.setState({ appointments });
		} catch (error) {
			console.log(error);
		}
		this.setState({ loading: false });
		this.props.setLoading(false);

		clearTimeout(timerId);
		const getAppointments = this.getAppointments.bind(this, { from, to });
		timerId = setTimeout(getAppointments, UPDATE_INTERVAL_IN_SECONDS * 1000);
	}

	render() {
		const {
			createAppointment,
			editAppointment,
			createVacation,
		} = this.props;

		return (
			<Calendar
				createAppointment={createAppointment}
				editAppointment={editAppointment}
				createVacation={createVacation}
				getAppointments={this.getAppointments}
				appointments={this.state.appointments}
			/>
		);
	}
}

const mapStateToProps = (state) => ({
	userId: state.auth?.auth?.id,
	selectedCustomerRepresentative: state.common.schedulerSettings.selectedUser,
});

export default connect(mapStateToProps)(CalendarView);
